import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkothrud() {



  const cardData = {



keyword: "Cab Service in Kothrud",

headingDescription: "Garud Cab Service provides comfortable and reliable Cab Service in Kothrud for corporate professionals, families, tourists, senior citizens, students, and groups looking for convenient local and outstation transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for office travel, airport transfers, railway station pickups, corporate meetings, local transportation, one-way journeys, round trips, sightseeing, and customized outstation trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Kothrud, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes business and leisure travel smooth and convenient. Travelers can also arrange private cabs from Kothrud to hill stations, pilgrimage destinations, coastal getaways, major cities, and other outstation locations according to their preferred schedule.",

topPlaces: [
  {
    title: "Goa",
    description: "Goa is a popular long-distance holiday destination known for beaches, forts, churches, markets, and scenic coastal landscapes. Families, couples, and groups from Kothrud can enjoy convenient door-to-door transportation in a private chauffeur-driven cab. Garud Cab Service offers suitable vehicles for one-way, round-trip, and multi-day Goa journeys with flexible travel plans."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination visited by devotees throughout the year for Sai Baba darshan. Families and senior citizens from Kothrud can travel comfortably in a private cab without changing vehicles. Customers can choose Sedan, Ertiga, Innova, or Innova Crysta and arrange one-way, round-trip, overnight, or customized pilgrimage travel."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a revered Jyotirlinga pilgrimage destination surrounded by forests and scenic Sahyadri mountain landscapes. Devotees from Kothrud can arrange a direct private cab for a comfortable family pilgrimage. Garud Cab Service provides professional chauffeurs, flexible pickup timings, and suitable vehicles for individual travelers and groups."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station known for viewpoints, waterfalls, lakes, valleys, and strawberry farms. It is an excellent choice for families and couples planning a relaxing road trip from Kothrud. Customers can book comfortable cabs with flexible sightseeing stops and combine Mahabaleshwar with Panchgani or nearby destinations."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious, cultural, and commercial city known for temples, heritage attractions, vineyards, and scenic surroundings. Travelers from Kothrud can book private cabs for pilgrimage, family visits, business travel, or sightseeing. Customers can customize their journey with multiple stops and flexible return arrangements."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal getaway known for beaches, forts, resorts, and peaceful seaside surroundings. Families and groups from Kothrud can plan a weekend trip with comfortable private transportation. Garud Cab Service offers flexible one-way and round-trip cabs with customized sightseeing options covering beaches and nearby attractions."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a culturally important city known for the Mahalaxmi Temple, historic attractions, traditional cuisine, and regional heritage. Travelers from Kothrud can arrange private cab transportation for pilgrimage, business travel, family visits, or sightseeing. Spacious vehicles provide comfortable seating and luggage capacity for long-distance journeys."
  },
  {
    title: "Ujjain",
    description: "Ujjain is an important pilgrimage city in Madhya Pradesh and is famous for the Mahakaleshwar Temple, one of the revered Jyotirlinga shrines. Devotees from Kothrud can plan a comfortable long-distance journey in an Innova or Innova Crysta. Customers can customize their itinerary with additional religious and sightseeing destinations."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a popular coastal and pilgrimage destination known for its beaches, temples, scenic landscapes, and peaceful atmosphere. It is suitable for travelers planning a longer holiday from Kothrud. Garud Cab Service provides spacious chauffeur-driven vehicles and flexible multi-day booking options for families and groups."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a major heritage destination offering historic monuments, caves, temples, and cultural attractions. Families, tourists, and business travelers from Kothrud can book private cabs for comfortable travel. Customers can customize their itinerary around heritage sightseeing, business requirements, or family visits."
  }
],




"services": [
  {
    "name": "Cab Service in Kothrud",
    "description": "Cab Service in Kothrud provides convenient local and outstation transportation for residents, professionals, students, families, and visitors. Sedan, SUV, Ertiga, Innova, and premium cab options can be arranged for airport transfers, railway station drops, local travel, sightseeing, business trips, and long-distance journeys."
  },
  {
    "name": "Cab Service in Kothrud Pune",
    "description": "Cab Service in Kothrud Pune offers private transportation from residential societies, offices, shopping areas, and other locations across Kothrud. Comfortable vehicles can be arranged for local rides, airport transfers, outstation trips, family travel, corporate requirements, and scheduled pickup and drop services."
  },
  {
    "name": "Taxi Service in Kothrud",
    "description": "Taxi Service in Kothrud provides comfortable transportation for daily travel, airport rides, railway station transfers, business meetings, family journeys, and outstation destinations. Customers can select suitable sedan, SUV, Ertiga, Innova, or premium vehicles based on passenger and luggage requirements."
  },
  {
    "name": "Taxi Service in Kothrud Pune",
    "description": "Taxi Service in Kothrud Pune is suitable for passengers looking for convenient private transportation within Pune and to nearby cities. Flexible cab options can be arranged for one-way journeys, round trips, airport transfers, sightseeing, corporate travel, and long-distance transportation."
  },
  {
    "name": "Kothrud Cab Service",
    "description": "Kothrud Cab Service provides reliable transportation for local and intercity travel from different parts of Kothrud. The service can be used for office travel, family trips, airport pickups and drops, railway station transfers, weekend journeys, and outstation destinations."
  },
  {
    "name": "Kothrud Taxi Service",
    "description": "Kothrud Taxi Service offers private cabs for passengers traveling within Pune or planning trips outside the city. Sedan, SUV, Ertiga, and Innova vehicles can be arranged for individuals, families, business travelers, and groups according to their journey requirements."
  },
  {
    "name": "Cab Booking in Kothrud",
    "description": "Cab Booking in Kothrud allows travelers to arrange transportation according to their preferred pickup time, destination, vehicle type, and journey plan. Cabs can be scheduled for local rides, airport transfers, railway station travel, corporate transportation, sightseeing, and outstation trips."
  },
  {
    "name": "Cabs in Kothrud Pune",
    "description": "Cabs in Kothrud Pune provide convenient transportation for everyday travel as well as longer journeys outside Pune. Customers can choose comfortable vehicles for airport transfers, family travel, business visits, local transportation, one-way drops, and round-trip outstation journeys."
  },
  {
    "name": "Cab Near Me in Kothrud",
    "description": "Cab Near Me in Kothrud helps passengers arrange convenient transportation from their nearby residential, commercial, or office location. Suitable cab categories can be selected for local travel, airport transfers, railway station drops, family trips, and outstation journeys."
  },
  {
    "name": "Taxi Near Me in Kothrud",
    "description": "Taxi Near Me in Kothrud provides a practical transportation option for passengers requiring a cab close to their pickup location. The service is suitable for daily travel, airport rides, railway station transfers, business travel, family transportation, and intercity journeys."
  },
  {
    "name": "Best Cab Service in Kothrud",
    "description": "Best Cab Service in Kothrud is suitable for travelers seeking comfortable and convenient transportation for different journey types. Well-maintained sedan, SUV, Ertiga, and Innova vehicles can be arranged for local rides, airport transfers, corporate travel, sightseeing, and outstation trips."
  },
  {
    "name": "Affordable Cab Service in Kothrud",
    "description": "Affordable Cab Service in Kothrud offers practical transportation choices for passengers looking for budget-conscious travel. Vehicle options can be selected according to passenger count, luggage, destination, and journey type, making the service suitable for local as well as outstation transportation."
  },
  {
    "name": "Reliable Taxi Service Kothrud",
    "description": "Reliable Taxi Service Kothrud provides scheduled private transportation for individuals, families, professionals, and groups. Cabs can be arranged for airport transfers, railway station travel, office visits, sightseeing, one-way drops, round trips, and long-distance journeys."
  },
  {
    "name": "Kothrud to Pune Airport Cab",
    "description": "Kothrud to Pune Airport Cab provides convenient airport transportation from residential areas, offices, and societies across Kothrud. Sedan, Ertiga, SUV, and Innova options can be arranged according to passenger count, luggage, pickup timing, and airport travel requirements."
  },
  {
    "name": "Pune Airport to Kothrud Cab",
    "description": "Pune Airport to Kothrud Cab offers private pickup transportation for passengers arriving at Pune Airport and traveling toward Kothrud. Comfortable AC vehicles can be arranged for individuals, families, corporate travelers, and passengers carrying additional luggage."
  },
  {
    "name": "Kothrud to Pune Airport Taxi",
    "description": "Kothrud to Pune Airport Taxi is suitable for travelers who need a convenient ride from Kothrud to Pune Airport. Airport drop services can be arranged with suitable sedan, SUV, Ertiga, and Innova vehicles based on travel time, passenger requirements, and luggage."
  },
  {
    "name": "Kothrud to Pune Airport Cab Fare",
    "description": "Kothrud to Pune Airport Cab Fare can depend on factors such as vehicle category, pickup location, travel requirements, and journey timing. Customers can select economical sedans or spacious SUV, Ertiga, and Innova options according to their airport transportation needs."
  },
  {
    "name": "Cheap Airport Cab from Kothrud",
    "description": "Cheap Airport Cab from Kothrud provides a practical option for passengers looking for economical transportation to Pune Airport. Suitable vehicles can be selected according to the number of passengers, luggage requirements, pickup point, and preferred travel schedule."
  },
  {
    "name": "Outstation Cab Service in Kothrud",
    "description": "Outstation Cab Service in Kothrud provides private transportation for travelers heading from Pune to destinations across Maharashtra and nearby states. One-way and round-trip cab options can be arranged with sedan, SUV, Ertiga, Innova, and premium vehicles for families, groups, and business travelers."
  },
  {
    "name": "One-Way Cab from Kothrud",
    "description": "One-Way Cab from Kothrud is suitable for passengers who need a direct drop to another city without requiring a return journey. Cabs can be arranged for destinations such as Mumbai, Nashik, Shirdi, Lonavala, Mahabaleshwar, Kolhapur, Goa, and other intercity locations."
  },
  {
    "name": "Round-Trip Cab from Kothrud",
    "description": "Round-Trip Cab from Kothrud provides convenient transportation for travelers planning return journeys from Pune to another destination. The service is suitable for family trips, sightseeing, temple visits, business travel, weekend tours, and planned intercity journeys."
  },
  {
    "name": "Kothrud to Mumbai Cab",
    "description": "Kothrud to Mumbai Cab offers private intercity transportation for passengers traveling between Pune and Mumbai. Sedan, SUV, Ertiga, and Innova options can be arranged for one-way drops, return trips, business travel, family journeys, and airport connections."
  },
  {
    "name": "Kothrud to Shirdi Cab",
    "description": "Kothrud to Shirdi Cab provides convenient transportation for devotees and families traveling from Pune to Shirdi. Private vehicles can be arranged for one-way travel, round trips, temple visits, family pilgrimages, and customized religious journeys."
  },
  {
    "name": "Kothrud to Nashik Cab",
    "description": "Kothrud to Nashik Cab is suitable for travelers heading from Pune to Nashik for business, family visits, sightseeing, religious travel, or weekend trips. Comfortable sedan, SUV, Ertiga, and Innova vehicles can be arranged for one-way and round-trip journeys."
  },
  {
    "name": "Kothrud to Lonavala Cab",
    "description": "Kothrud to Lonavala Cab provides convenient transportation for weekend trips, family outings, sightseeing, and short getaways from Pune. Customers can select comfortable vehicles for one-way travel, return journeys, or customized Lonavala sightseeing plans."
  },
  {
    "name": "Kothrud to Mahabaleshwar Cab",
    "description": "Kothrud to Mahabaleshwar Cab offers private transportation for families, couples, and groups traveling to the hill station. Sedan, Ertiga, SUV, and Innova options can be arranged for one-way drops, round trips, sightseeing, and weekend travel."
  },
  {
    "name": "Kothrud to Bhimashankar Cab",
    "description": "Kothrud to Bhimashankar Cab provides comfortable transportation for devotees and travelers visiting the temple and surrounding attractions. Private cabs can be arranged for one-day trips, round journeys, family pilgrimages, and customized sightseeing plans."
  },
  {
    "name": "Kothrud to Alibaug Cab",
    "description": "Kothrud to Alibaug Cab is suitable for families, friends, and groups planning coastal getaways from Pune. Comfortable private vehicles can be arranged for one-way travel, round trips, beach visits, weekend tours, and customized Alibaug sightseeing."
  },
  {
    "name": "Kothrud to Kolhapur Cab",
    "description": "Kothrud to Kolhapur Cab offers private intercity transportation for passengers traveling for business, family visits, religious trips, and sightseeing. Sedan, SUV, Ertiga, and Innova vehicles can be arranged for direct drops or return journeys."
  },
  {
    "name": "Kothrud to Goa Cab",
    "description": "Kothrud to Goa Cab provides long-distance private transportation for families, friends, couples, and corporate travelers. Vehicle options can be selected for one-way travel, round trips, beach holidays, weekend journeys, and customized Goa travel plans."
  },
  {
    "name": "Kothrud to Jejuri Cab",
    "description": "Kothrud to Jejuri Cab is suitable for devotees traveling to Khandoba Temple and nearby religious destinations. Comfortable cabs can be arranged for one-way travel, return journeys, family Darshan trips, and combined temple sightseeing."
  },
  {
    "name": "Kothrud to Ashtavinayak Cab",
    "description": "Kothrud to Ashtavinayak Cab provides private transportation for devotees planning Ashtavinayak temple tours from Pune. Sedan, SUV, Ertiga, Innova, and larger vehicles can be arranged for one-day, multi-day, family, and customized pilgrimage journeys."
  },
  {
    "name": "Sedan Cab in Kothrud",
    "description": "Sedan Cab in Kothrud provides a comfortable transportation option for individuals, couples, and small families. Sedan cars can be arranged for local travel, airport transfers, business meetings, railway station drops, sightseeing, and outstation journeys."
  },
  {
    "name": "Swift Dzire Cab in Kothrud",
    "description": "Swift Dzire Cab in Kothrud is a practical choice for passengers seeking comfortable transportation for daily and intercity travel. The vehicle can be arranged for airport transfers, local rides, one-way drops, round trips, business travel, and family journeys."
  },
  {
    "name": "Ertiga Cab in Kothrud",
    "description": "Ertiga Cab in Kothrud offers spacious transportation for families and small groups. It can be arranged for airport transfers, local travel, weekend trips, outstation journeys, sightseeing, and long-distance travel where additional passenger and luggage space is useful."
  },
  {
    "name": "Innova Cab in Kothrud",
    "description": "Innova Cab in Kothrud provides a spacious option for families, groups, and business travelers. The vehicle is suitable for airport transfers, outstation journeys, sightseeing, religious trips, weekend travel, and long-distance transportation."
  },
  {
    "name": "Innova Crysta Rental Kothrud",
    "description": "Innova Crysta Rental Kothrud provides premium and spacious transportation for families, corporate travelers, groups, and special journeys. The vehicle can be arranged for airport transfers, outstation trips, sightseeing, business travel, and comfortable long-distance journeys."
  },
  {
    "name": "7-Seater Cab in Kothrud",
    "description": "7-Seater Cab in Kothrud is suitable for families and groups requiring additional seating capacity. Spacious vehicles can be arranged for airport transfers, weekend trips, sightseeing, pilgrimage tours, and outstation journeys with luggage."
  },
  {
    "name": "Tempo Traveller in Kothrud",
    "description": "Tempo Traveller in Kothrud provides group transportation for larger families, friends, corporate teams, and tour groups. It can be arranged for outstation trips, pilgrimage tours, sightseeing, weekend holidays, multi-day tours, and customized travel itineraries."
  },
  {
    "name": "Luxury Car Rental in Kothrud",
    "description": "Luxury Car Rental in Kothrud offers premium transportation for business travel, special occasions, executive movements, events, and comfortable long-distance journeys. Premium vehicle options can be arranged according to passenger requirements and travel plans."
  },
  {
    "name": "Outstation Cab Service in Karve Nagar",
    "description": "Outstation Cab Service in Karve Nagar provides private transportation from Karve Nagar to destinations across Maharashtra and nearby states. One-way and round-trip options can be arranged with comfortable sedan, SUV, Ertiga, Innova, and premium vehicles."
  },
  {
    "name": "One-Way Cab from Karve Nagar",
    "description": "One-Way Cab from Karve Nagar is suitable for travelers requiring a direct intercity drop without a return booking. Private cabs can be arranged for Mumbai, Shirdi, Nashik, Lonavala, Mahabaleshwar, Kolhapur, Goa, and other destinations."
  },
  {
    "name": "Round-Trip Taxi from Karve Nagar",
    "description": "Round-Trip Taxi from Karve Nagar provides convenient return transportation for family trips, sightseeing, religious journeys, business visits, and weekend travel. Comfortable vehicles can be arranged according to passenger count, luggage, destination, and trip duration."
  },
  {
    "name": "Karve Nagar to Mumbai Cab",
    "description": "Karve Nagar to Mumbai Cab offers convenient private transportation between Pune and Mumbai. Sedan, SUV, Ertiga, and Innova options can be arranged for business travel, family journeys, airport connections, one-way drops, and round trips."
  },
  {
    "name": "Karve Nagar to Shirdi Cab",
    "description": "Karve Nagar to Shirdi Cab provides private transportation for devotees and families traveling from Pune to Shirdi. The service can be arranged for direct drops, return journeys, temple Darshan, family pilgrimages, and customized religious trips."
  },
  {
    "name": "Karve Nagar to Nashik Cab",
    "description": "Karve Nagar to Nashik Cab is suitable for business travel, family visits, sightseeing, religious journeys, and weekend trips. Comfortable private vehicles can be arranged for one-way and round-trip travel between Karve Nagar and Nashik."
  },
  {
    "name": "Karve Nagar to Lonavala Cab",
    "description": "Karve Nagar to Lonavala Cab provides convenient transportation for weekend getaways, family outings, sightseeing, and short leisure trips. Sedan, SUV, Ertiga, and Innova options can be arranged for one-way travel or return journeys."
  },
  {
    "name": "Karve Nagar to Mahabaleshwar Cab",
    "description": "Karve Nagar to Mahabaleshwar Cab offers comfortable private transportation for families, couples, and groups visiting the hill station. Cabs can be arranged for direct drops, round trips, sightseeing, and weekend holiday travel."
  },
  {
    "name": "Karve Nagar to Bhimashankar Cab",
    "description": "Karve Nagar to Bhimashankar Cab provides convenient transportation for devotees and travelers visiting Bhimashankar Temple. Private cabs can be arranged for one-day pilgrimages, family trips, round journeys, and nearby sightseeing."
  },
  {
    "name": "Karve Nagar to Alibaug Cab",
    "description": "Karve Nagar to Alibaug Cab is suitable for families, friends, and groups planning coastal holidays from Pune. Comfortable vehicles can be arranged for one-way travel, round trips, beach visits, weekend tours, and sightseeing."
  },
  {
    "name": "Karve Nagar to Kolhapur Cab",
    "description": "Karve Nagar to Kolhapur Cab provides private intercity transportation for business travel, family visits, temple trips, and sightseeing. Sedan, SUV, Ertiga, and Innova vehicles can be selected for one-way or round-trip journeys."
  },
  {
    "name": "Karve Nagar to Goa Cab",
    "description": "Karve Nagar to Goa Cab offers long-distance transportation for families, friends, couples, and corporate travelers. Suitable vehicles can be arranged for one-way travel, return journeys, beach holidays, weekend trips, and customized Goa tours."
  },
  {
    "name": "Karve Nagar to Jejuri Cab",
    "description": "Karve Nagar to Jejuri Cab provides convenient transportation for devotees visiting Khandoba Temple. The service can be arranged for direct travel, return journeys, family Darshan, and combined temple sightseeing around Jejuri."
  },
  {
    "name": "Karve Nagar to Ashtavinayak Cab",
    "description": "Karve Nagar to Ashtavinayak Cab is suitable for devotees planning Ashtavinayak temple tours from Pune. Comfortable vehicles can be arranged for one-day trips, multi-day pilgrimage tours, family travel, group journeys, and customized temple itineraries."
  }
],
"tableData": [
  ["Cab Service in Kothrud", "Cab Service in Kothrud Pune"],
  ["Taxi Service in Kothrud", "Taxi Service in Kothrud Pune"],
  ["Kothrud Cab Service", "Kothrud Taxi Service"],
  ["Cab Booking in Kothrud", "Cabs in Kothrud Pune"],
  ["Cab Near Me in Kothrud", "Taxi Near Me in Kothrud"],
  ["Best Cab Service in Kothrud", "Affordable Cab Service in Kothrud"],
  ["Reliable Taxi Service Kothrud", "Kothrud to Pune Airport Cab"],
  ["Pune Airport to Kothrud Cab", "Kothrud to Pune Airport Taxi"],
  ["Kothrud to Pune Airport Cab Fare", "Cheap Airport Cab from Kothrud"],
  ["Outstation Cab Service in Kothrud", "One-Way Cab from Kothrud"],
  ["Round-Trip Cab from Kothrud", "Kothrud to Mumbai Cab"],
  ["Kothrud to Shirdi Cab", "Kothrud to Nashik Cab"],
  ["Kothrud to Lonavala Cab", "Kothrud to Mahabaleshwar Cab"],
  ["Kothrud to Bhimashankar Cab", "Kothrud to Alibaug Cab"],
  ["Kothrud to Kolhapur Cab", "Kothrud to Goa Cab"],
  ["Kothrud to Jejuri Cab", "Kothrud to Ashtavinayak Cab"],
  ["Sedan Cab in Kothrud", "Swift Dzire Cab in Kothrud"],
  ["Ertiga Cab in Kothrud", "Innova Cab in Kothrud"],
  ["Innova Crysta Rental Kothrud", "7-Seater Cab in Kothrud"],
  ["Tempo Traveller in Kothrud", "Luxury Car Rental in Kothrud"],
  ["Outstation Cab Service in Karve Nagar", "One-Way Cab from Karve Nagar"],
  ["Round-Trip Taxi from Karve Nagar", "Karve Nagar to Mumbai Cab"],
  ["Karve Nagar to Shirdi Cab", "Karve Nagar to Nashik Cab"],
  ["Karve Nagar to Lonavala Cab", "Karve Nagar to Mahabaleshwar Cab"],
  ["Karve Nagar to Bhimashankar Cab", "Karve Nagar to Alibaug Cab"],
  ["Karve Nagar to Kolhapur Cab", "Karve Nagar to Goa Cab"],
  ["Karve Nagar to Jejuri Cab", "Karve Nagar to Ashtavinayak Cab"]
]
,



whychoose: [
  {
    WhyChooseheading: "Cab Service in Kothrud for Comfortable Local Travel",
    WhyChoosedescription: "Private cab transportation in Kothrud is a practical option for residents, professionals, families, students, and visitors travelling to offices, educational institutions, hospitals, shopping areas, airports, railway stations, and outstation destinations."
  },
  {
    WhyChooseheading: "Convenient Pickup from Kothrud",
    WhyChoosedescription: "Passengers can arrange pickup from their home, apartment, office, hotel, residential society, commercial location, or another accessible point in Kothrud according to their preferred travel schedule."
  },
  {
    WhyChooseheading: "Useful for Office & Business Travel",
    WhyChoosedescription: "Professionals and companies can arrange private cabs for office commutes, client meetings, business appointments, corporate events, and travel between Kothrud and other important commercial areas of Pune."
  },
  {
    WhyChooseheading: "Airport & Railway Station Transfers",
    WhyChoosedescription: "A private cab can be booked for transportation from Kothrud to Pune Airport, Pune Railway Station, and other transport points, providing direct travel for passengers with luggage."
  },
  {
    WhyChooseheading: "Suitable for Families & Groups",
    WhyChoosedescription: "Families, couples, and groups can select a suitable vehicle based on passenger count, luggage requirements, travel distance, and preferred comfort level for everyday and longer journeys."
  },
  {
    WhyChooseheading: "Convenient for Education & Medical Visits",
    WhyChoosedescription: "Cab transportation in Kothrud can be useful for students, parents, patients, attendants, and visitors travelling to educational institutions, hospitals, clinics, residential areas, and other planned destinations."
  },
  {
    WhyChooseheading: "One-Way & Outstation Travel Options",
    WhyChoosedescription: "Travellers can arrange one-way or round-trip cabs from Kothrud to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Satara, Shirdi, Goa, and other preferred cities."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Kothrud pickup point, destination, travel date, passenger count, luggage details, preferred vehicle, and local or outstation requirement with Garud Cab Service for suitable booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Cab Service in Kothrud?",
    answer: "Yes, Garud Cab Service provides private cab services in Kothrud for local travel, corporate transportation, airport transfers, railway station travel, family trips, educational visits, and outstation journeys."
  },
  {
    question: "Can I book a cab from anywhere in Kothrud?",
    answer: "Yes, pickup can be arranged from a preferred accessible location in Kothrud, including homes, apartments, offices, hotels, residential societies, and commercial locations."
  },
  {
    question: "Can I book a cab from Kothrud to Pune Airport?",
    answer: "Yes, private airport transfer services can be arranged from Kothrud to Pune Airport according to your preferred travel date and flight schedule."
  },
  {
    question: "Can I book a cab from Kothrud to Pune Railway Station?",
    answer: "Yes, a private cab can be arranged for direct transportation from Kothrud to Pune Railway Station or another preferred railway station location."
  },
  {
    question: "Can companies book cabs in Kothrud?",
    answer: "Yes, companies can arrange private cabs for employee travel, client meetings, office visits, corporate events, business appointments, and other professional transportation requirements."
  },
  {
    question: "Is the Kothrud cab service suitable for families?",
    answer: "Yes, families and groups can select a suitable vehicle according to passenger numbers, luggage requirements, journey distance, and preferred comfort level."
  },
  {
    question: "Does the service provide outstation cabs from Kothrud?",
    answer: "Yes, one-way and round-trip outstation cabs can be arranged from Kothrud to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Satara, Shirdi, Goa, and other cities."
  },
  {
    question: "Can I book a one-way cab from Kothrud?",
    answer: "Yes, one-way cab service can be arranged when you need direct transportation from Kothrud to your preferred destination without requiring the same vehicle for the return journey."
  },
  {
    question: "Can I carry luggage in a Kothrud cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger or additional baggage requirements should be communicated during booking."
  },
  {
    question: "How can I book a Cab Service in Kothrud?",
    answer: "Share your Kothrud pickup location, destination, travel date, passenger details, luggage requirements, preferred vehicle, and local or outstation travel requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Bhosale",
    feedback: "I arranged a cab from Kothrud for a railway station transfer and found the direct pickup very convenient. The private vehicle was also useful for carrying my travel bags.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Joshi",
    feedback: "Our family booked a cab in Kothrud for an outstation journey. Travelling together in a private vehicle made the trip easier to organize and comfortable for everyone.",
    rating: 5
  }
];



  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kothrud",
  "image": "https://garudcabs.com/assets/images/cab-service-in-kothrud.webp",
  "description": "Book Cab Service in Kothrud with Garud Cab for safe, comfortable, and reliable local, airport, corporate, and outstation transportation. Get taxi and cab booking services across Kothrud Pune for daily commuting, business travel, airport transfers, family journeys, sightseeing, and intercity trips. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient pickup and drop facilities, flexible one way and round trip options, and professional drivers for a smooth travel experience.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/cab-service-in-kothrud"
  }
};


  return (
    <div>




<Helmet>
  <title>Cab Service in Kothrud | Taxi & Cab Booking Pune | +91 9970007784</title>

  <meta
    name="description"
    content="Book Cab Service in Kothrud Pune with Garud Cab for reliable local, airport, corporate, and outstation travel. Get taxi and cab booking services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Cab Service in Kothrud, Cab Service in Kothrud Pune, Taxi Service in Kothrud, Taxi Service in Kothrud Pune, Kothrud Cab Service, Kothrud Taxi Service, Cab Booking in Kothrud, Cabs in Kothrud Pune, Cab Near Me in Kothrud, Taxi Near Me in Kothrud, Kothrud Outstation Cab, Kothrud Airport Cab, Kothrud Local Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/113.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkothrud;